import { ButtonHTMLAttributes } from 'react';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
}
export const IconButton = ({ className, children, ...rest }: IconButtonProps) => (
  <button type="button" className={`flex justify-center items-center active:brightness-90 ${className}`} {...rest}>
    {children}
  </button>
);
